"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextRawProps = exports.buildTextClassName = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cosmicUnwidower = require("@designbycosmic/cosmic-unwidower");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Renders HTML text content with predefined Tailwind classNames.
 * To use in a project, you should wrap `Text` in a decorator component
* 
  ```
    import { Text as TextRaw } from "@designbycosmic/cosmic-react-conmmon-components";

     const config = {
      typography: {
        h1: {
          font: "font-sans",
          size: "text-2xl sm:text-3xl",
          style: "font-bold",
          lineHeight: "leading-1.4",
          letterSpacing: "tracking-sm",
        },
        p: {
          font: "font-sans",
          size: "text-base",
          style: "font-normal",
          lineHeight: "leading-1.9",
          letterSpacing: "tracking-sm",
        },
      },
    };
    
    const Text = props => (
      <TextRaw {...props} config={config} />
    );

    export default Text;
  ```
 */


var buildTextClassName = function buildTextClassName(typographyConfig, tag, use, options, className) {
  // Merge the default className object for the passed Tag
  // with any options also passed
  var classNameObject = _objectSpread({}, typographyConfig[use || tag] || {}, {}, options); // Process the object into a single className string


  return Object.values(classNameObject).reduce(function (str, cur) {
    return "".concat(str, " ").concat(cur);
  }, className);
};

exports.buildTextClassName = buildTextClassName;

var TextRaw = function TextRaw(_ref) {
  var Tag = _ref.tag,
      use = _ref.use,
      options = _ref.options,
      _className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      preserveWidows = _ref.preserveWidows,
      config = _ref.config,
      rest = _objectWithoutProperties(_ref, ["tag", "use", "options", "className", "style", "children", "preserveWidows", "config"]);

  if (!Tag || !config || _typeof(config) !== "object") {
    return null;
  }

  var _config$typography = config.typography,
      typography = _config$typography === void 0 ? {} : _config$typography,
      _config$unwidower = config.unwidower,
      unwidower = _config$unwidower === void 0 ? {} : _config$unwidower; // Apply the UnWidower to the children text content unless
  // `preserveWidows` was passed

  var Content = function Content() {
    if (!preserveWidows) {
      return _react.default.createElement(_cosmicUnwidower.UnWidowerReactChildren, {
        config: unwidower
      }, children);
    }

    return children;
  };

  var className = buildTextClassName(typography, Tag, use, options, _className);
  return _react.default.createElement(Tag, _extends({}, rest, {
    className: "CosmicText ".concat(className),
    style: style
  }), _react.default.createElement(Content, null));
};

var TextRawProps = {
  config: _propTypes.default.shape({
    typography: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.objectOf(_propTypes.default.string)])).isRequired,
    unwidower: _propTypes.default.objectOf(_propTypes.default.number)
  }).isRequired,
  tag: _propTypes.default.string.isRequired,
  options: _propTypes.default.objectOf(_propTypes.default.string),
  use: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  preserveWidows: _propTypes.default.bool
};
exports.TextRawProps = TextRawProps;
TextRaw.propTypes = TextRawProps;
TextRaw.defaultProps = {
  options: {},
  use: undefined,
  className: "",
  style: {},
  preserveWidows: false
};
var _default = TextRaw;
exports.default = _default;